/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as DashboardRouteImport } from './routes/dashboard'
import { Route as AgendaRouteImport } from './routes/agenda'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ProfesionalesIndexRouteImport } from './routes/profesionales.index'
import { Route as PacientesIndexRouteImport } from './routes/pacientes.index'
import { Route as ProfesionalesIdRouteImport } from './routes/profesionales.$id'
import { Route as PacientesIdRouteImport } from './routes/pacientes.$id'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRoute = DashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const AgendaRoute = AgendaRouteImport.update({
  id: '/agenda',
  path: '/agenda',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfesionalesIndexRoute = ProfesionalesIndexRouteImport.update({
  id: '/profesionales/',
  path: '/profesionales/',
  getParentRoute: () => rootRouteImport,
} as any)
const PacientesIndexRoute = PacientesIndexRouteImport.update({
  id: '/pacientes/',
  path: '/pacientes/',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfesionalesIdRoute = ProfesionalesIdRouteImport.update({
  id: '/profesionales/$id',
  path: '/profesionales/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const PacientesIdRoute = PacientesIdRouteImport.update({
  id: '/pacientes/$id',
  path: '/pacientes/$id',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/agenda': typeof AgendaRoute
  '/dashboard': typeof DashboardRoute
  '/login': typeof LoginRoute
  '/pacientes/$id': typeof PacientesIdRoute
  '/profesionales/$id': typeof ProfesionalesIdRoute
  '/pacientes/': typeof PacientesIndexRoute
  '/profesionales/': typeof ProfesionalesIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/agenda': typeof AgendaRoute
  '/dashboard': typeof DashboardRoute
  '/login': typeof LoginRoute
  '/pacientes/$id': typeof PacientesIdRoute
  '/profesionales/$id': typeof ProfesionalesIdRoute
  '/pacientes': typeof PacientesIndexRoute
  '/profesionales': typeof ProfesionalesIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/agenda': typeof AgendaRoute
  '/dashboard': typeof DashboardRoute
  '/login': typeof LoginRoute
  '/pacientes/$id': typeof PacientesIdRoute
  '/profesionales/$id': typeof ProfesionalesIdRoute
  '/pacientes/': typeof PacientesIndexRoute
  '/profesionales/': typeof ProfesionalesIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/agenda'
    | '/dashboard'
    | '/login'
    | '/pacientes/$id'
    | '/profesionales/$id'
    | '/pacientes/'
    | '/profesionales/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/agenda'
    | '/dashboard'
    | '/login'
    | '/pacientes/$id'
    | '/profesionales/$id'
    | '/pacientes'
    | '/profesionales'
  id:
    | '__root__'
    | '/'
    | '/agenda'
    | '/dashboard'
    | '/login'
    | '/pacientes/$id'
    | '/profesionales/$id'
    | '/pacientes/'
    | '/profesionales/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AgendaRoute: typeof AgendaRoute
  DashboardRoute: typeof DashboardRoute
  LoginRoute: typeof LoginRoute
  PacientesIdRoute: typeof PacientesIdRoute
  ProfesionalesIdRoute: typeof ProfesionalesIdRoute
  PacientesIndexRoute: typeof PacientesIndexRoute
  ProfesionalesIndexRoute: typeof ProfesionalesIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard': {
      id: '/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/agenda': {
      id: '/agenda'
      path: '/agenda'
      fullPath: '/agenda'
      preLoaderRoute: typeof AgendaRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profesionales/': {
      id: '/profesionales/'
      path: '/profesionales'
      fullPath: '/profesionales/'
      preLoaderRoute: typeof ProfesionalesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pacientes/': {
      id: '/pacientes/'
      path: '/pacientes'
      fullPath: '/pacientes/'
      preLoaderRoute: typeof PacientesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profesionales/$id': {
      id: '/profesionales/$id'
      path: '/profesionales/$id'
      fullPath: '/profesionales/$id'
      preLoaderRoute: typeof ProfesionalesIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pacientes/$id': {
      id: '/pacientes/$id'
      path: '/pacientes/$id'
      fullPath: '/pacientes/$id'
      preLoaderRoute: typeof PacientesIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AgendaRoute: AgendaRoute,
  DashboardRoute: DashboardRoute,
  LoginRoute: LoginRoute,
  PacientesIdRoute: PacientesIdRoute,
  ProfesionalesIdRoute: ProfesionalesIdRoute,
  PacientesIndexRoute: PacientesIndexRoute,
  ProfesionalesIndexRoute: ProfesionalesIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
